export const convertSimpleGeoPoint = (geoPoint: number): number =>
  Math.floor(geoPoint * 1000000) / 1000000;
